/* msd-tabs.js (v50) – filele și săgețile secțiunii msd-product-tabs. Filele 2+ se încarcă la prima apăsare. */
if (!customElements.get('msd-ptabs')) {
  customElements.define('msd-ptabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('.msd-pt__tab')];
      this.tabs.forEach((t) => {
        t.addEventListener('click', () => this.show(t));
        t.addEventListener('pointerenter', () => this.load(this.panelOf(t)), { once: true });
      });
      this.querySelectorAll('.msd-pt__arr').forEach((a) => a.addEventListener('click', () => {
        const l = this.list(); if (!l) return;
        l.scrollBy({ left: Number(a.dataset.dir) * l.clientWidth * 0.9, behavior: 'smooth' });
      }));
      this.bind();
    }
    panelOf(t) { return this.querySelector('#' + t.getAttribute('aria-controls')); }
    list() { const p = this.querySelector('.msd-pt__panel:not([hidden])'); return p && p.querySelector('.msd-pt__list'); }
    bind() {
      const l = this.list(); if (!l) return;
      const upd = () => {
        const prev = this.querySelector('.msd-pt__arr--prev'), next = this.querySelector('.msd-pt__arr--next');
        if (prev) prev.disabled = l.scrollLeft < 8;
        if (next) next.disabled = l.scrollLeft + l.clientWidth >= l.scrollWidth - 8;
      };
      if (!l._msd) { l._msd = 1; l.addEventListener('scroll', upd, { passive: true }); }
      upd();
    }
    load(p) {
      if (!p || p._loading || p.querySelector('.msd-pt__item')) return p && p._loading;
      const url = p.dataset.url; if (!url) return;
      p._loading = fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=msd-tab-items')
        .then((r) => r.text())
        .then((h) => {
          const d = new DOMParser().parseFromString(h, 'text/html').querySelector('.msd-pt__list');
          const l = p.querySelector('.msd-pt__list');
          if (d && l) l.innerHTML = d.innerHTML;
        }).catch(() => { p._loading = null; });
      return p._loading;
    }
    show(t) {
      this.tabs.forEach((x) => {
        const on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        const p = this.panelOf(x); if (p) p.hidden = !on;
      });
      const p = this.panelOf(t);
      Promise.resolve(this.load(p)).then(() => { const l = this.list(); if (l) l.scrollLeft = 0; this.bind(); });
    }
  });
}
